/* eslint-disable */
import Vue from "vue";

export default {
  install() {
    Vue.prototype.$toastr = (type, text, title = null) => {
      Vue.prototype.$notify({
        group: "ConveyNotification",
        type,
        text,
        title,
        closeOnClick: false,
      });
    };
  }
};
